<script>
import InfoBackgroundModule from './templates/InfoBackgroundModule.vue';
import InfoImageModule from './templates/InfoImageModule.vue';
import InfoCardsModule from './templates/InfoCardsModule.vue';
import InfoContactModule from './templates/InfoContactModule.vue';
import CTABackgroundModule from './templates/CTABackgroundModule.vue';
import CTAImageModule from './templates/CTAImageModule.vue';
import CTAReadyOrderModule from './templates/CTAReadyOrderModule.vue';
import ProductSelectModule from './templates/ProductSelectModule.vue';
import GallerySelectModule from './templates/GallerySelectModule.vue';
import CollectionCardsModule from './templates/CollectionCardsModule.vue';
import EnhanceWizardModule from './templates/EnhanceWizardModule.vue';
import CreateWizardModule from './templates/CreateWizardModule.vue';

const TEMPLATE_COMPONENTS = {
  'info-contact': InfoContactModule,
  'info-background': InfoBackgroundModule,
  'info-background-left': InfoBackgroundModule,
  'info-background-right': InfoBackgroundModule,
  'info-image-left': InfoImageModule,
  'info-image-right': InfoImageModule,
  'info-cards': InfoCardsModule,
  'cta-background-left': CTABackgroundModule,
  'cta-background-right': CTABackgroundModule,
  'cta-image-left': CTAImageModule,
  'cta-image-right': CTAImageModule,
  'cta-ready-order': CTAReadyOrderModule,
  'product-select': ProductSelectModule,
  'gallery-select': GallerySelectModule,
  'collection-cards': CollectionCardsModule,
  'gallery-cards': CollectionCardsModule,
  'enhance-wizard': EnhanceWizardModule,
  'create-wizard': CreateWizardModule,
};

export default {
  components: {
    InfoBackgroundModule,
    InfoImageModule,
    InfoCardsModule,
    InfoContactModule,
    CTABackgroundModule,
    CTAImageModule,
    CTAReadyOrderModule,
    ProductSelectModule,
    GallerySelectModule,
    CollectionCardsModule,
    EnhanceWizardModule,
    CreateWizardModule,
  },
  props: {
    moduleData: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
    blockIndex: {
      type: Number,
      default: 0,
    },
    companyColors: {
      type: Object,
      default: () => ({
        color1: '',
        color2: '',
        color3: '',
      }),
    },
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ['update', 'select', 'selection-change'],
  computed: {
    templateComponent() {
      const templateId = this.moduleData?.templateId
        || this.moduleData?.parsedContent?.templateId
        || 'info-basic';
      return TEMPLATE_COMPONENTS[templateId] || null;
    },
    blockBackground() {
      if (this.blockIndex % 2 === 1) {
        return this.companyColors.color3 || 'transparent';
      }
      return 'transparent';
    },
  },
  methods: {
    handleUpdate(updatedModule) {
      this.$emit('update', updatedModule);
    },
    handleSelect(data) {
      this.$emit('select', data);
    },
    handleSelectionChange(data) {
      this.$emit('selection-change', data);
    },
  },
};
</script>

<template>
  <component
    :is="templateComponent"
    :module-data="moduleData"
    :is-edit-mode="isEditMode"
    :is-mobile="isMobile"
    :is-popup="isPopup"
    :block-index="blockIndex"
    :block-background="blockBackground"
    :company-colors="companyColors"
    :company-id="companyId"
    @update="handleUpdate"
    @select="handleSelect"
    @selection-change="handleSelectionChange"
  />
</template>
